<script>
    import app from "../stores/app";
    import user from "../stores/user";
    import transfers from "../stores/transfers";
    import R, {LOADER} from "../lib/requests";
    import {
        USER_ROLE,
        ROUTE_TYPE,
        CUSTOMER_TYPE,
        CUSTOMER_TYPES,
        TRANSFER_STATUSES,
        TRANSFER_STATUS, PAYMENT_TYPE, TRANSFERS_SOURCE
    } from "../lib/constants";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import {copyObject, formatDate, getDate, setFocusTo} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TransferVehicles from "./TransferVehicles.svelte";
    import TransferCommissions from "./TransferCommissions.svelte";
    import TimeControl from "../components/controls/TimeControl.svelte";
    import NumberSpinner from "../components/controls/NumberSpinner.svelte";
    import PriceControl from "../components/controls/PriceControl.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Breadcrumb from "../components/Breadcrumb.svelte";
    import PageNotFound from "../components/pages/PageNotFound.svelte";
    import DateControl from "../components/controls/DateControl.svelte";
    import RouteLocation from "../components/controls/RouteLocation.svelte";
    import TransferReservation from "./TransferReservation.svelte";

    export let tourId = null;

    let breadcrumb = [
        {id: 'transfers', name: 'Transfers', link: `/app/transfers`}
    ];

    let tour = null;
    let initData = {};
    let defaultLocations = [];
    let hotels = [];

    let account = null;
    let transferUser = null;

    let users = [];
    let departments = [];
    let pickup = null;
    let transferDate = null;
    let transferTime = null;
    let commissions = [];
    let statuses = [];
    let maxPassengers = 0;
    let totalPassengers = 0;
    let customerTypes = [];
    let pageTitle = "";

    const channel = new BroadcastChannel('app');

    const initialize = () => {

        const onSuccess = result => {
            initData = result;

            if (tourId == 0) {
                setTransferData();
            } else {
                load();
            }
        }

        const onFailure = err => {
        };

        R.handle(R.transfer.initialize, [], onSuccess, onFailure, LOADER.PAGE);
    }

    const setTransferData = () => {
        if (tourId == 0) {
            tour = {
                id: 0,
                group_id: 0,
                user_id: $user.id,
                department_id: 0,
                account_id: 0,
                tour_id: 0,
                customer_id: 0,
                customer: {
                    fullname: '',
                    phone: '',
                    email: '',
                    room_no: '',
                },

                customer_type: 0,
                payment_type: 0,

                route_type: ROUTE_TYPE.TOUR,
                pickup_id: null,
                pickup_name: '',
                pickup_address: '',
                drop_id: null,
                drop_name: '',
                drop_address: '',

                vehicles: [{
                    vehicle_type_id: $app.vehicle_types[0].id,
                    vehicle: null,
                    driver: null,
                    transporter_id: 0,
                }],
                adults: 1,
                children: 0,
                infants: 0,
                booster_seats: 0,
                baby_seats: 0,
                infant_seats: 0,

                transfer_at: getDate(),
                status_id: 0,
                commissions: [],
            }
        }

        account = initData.accounts.find(x => x.id == tour.account_id);
        transferDate = formatDate(tour.transfer_at, 'y-m-d');
        transferTime = formatDate(tour.transfer_at, 'H:i');
        tour.customer_type = parseInt(tour.customer_type);
        tour.payment_type = parseInt(tour.payment_type);
        tour.status_id = parseInt(tour.status_id);
        commissions = tour.commissions;

        if (tour.id > 0) {
            pickup = tour.pickup;
            delete (tour.pickup);
            delete (tour.drop);
            delete (tour.tour);
        }

        pageTitle = tour.id > 0 ? `Tour ${tour.code ?? ''}` : "New Tour";

        initDepartments();
        initUsers();
        if (tour.department_id > 0) {
            onDepartmentChange();
        }
    }

    const load = () => {
        const onSuccess = result => {
            tour = result;
            // pageTitle = `Tour ${tour.code ? tour.code : ''}`;
            if (tour.user) {
                transferUser = tour.user;
                delete (tour.user);
            }
            setTransferData();
        }

        const onFailure = err => {
            tourId = -1;
        };

        R.handle(R.transfer.details, tourId, onSuccess, onFailure, LOADER.PAGE);
    }

    const save = () => {

        const onSuccess = result => {
            tour.id = result.id;
            tour.transfer_at = result.transfer_at;

            Notifier.showMessage("Tour saved");
            $transfers.changed = true;

            channel.postMessage({
                type: 'transfer/update',
                data: tour
            });
        }

        const onFailure = err => {
        };

        if (tour.payment_type == PAYMENT_TYPE.ON_ACCOUNT && tour.account_id == 0) {
            Alert.warning("No account", 'Payment type is "On Account" but there is no account related to tour!');
            return;
        }

        if (!pickup) {
            Notifier.showError("Select pickup location!");
            return;
        }

        if (!tour.tour_id) {
            Notifier.showError("Select tour!");
            return;
        }

        if (!transferDate) {
            Notifier.showError("Tour date not specified!");
            setFocusTo("transferDate");
            return;
        }

        if (!transferTime) {
            Notifier.showError("Tour time not specified!");
            setFocusTo("transferTime");
            return;
        }

        if (totalPassengers > maxPassengers) {
            Notifier.showError("Too many passengers!\nConsider adding more vehicles");
            return;
        }

        tour.customer.fullname = tour.customer.fullname.trim();
        if (!tour.customer.fullname) {
            Notifier.showError("Enter customer name!");
            setFocusTo("customerName");
            return;
        }

        tour.transfer_at = `${transferDate} ${transferTime}`;

        tour.pickup_id = pickup.id;
        tour.pickup_name = pickup.name;
        tour.pickup_address = pickup.address;

        let totalCommissions = 0;
        tour.commissions = [];
        commissions.map(item => {
            tour.commissions.push({
                object_type: item.object_type,
                object_id: item.object_id,
                vehicle_id: item.vehicle_id,
                price: item.price,
                is_custom: item.is_custom
            });
            totalCommissions += parseFloat(item.price);
        });
        if (totalCommissions > tour.price) {
            Alert.warning("Commissions", "Commissions are greater than the tour price!");
            return;
        }

        let action = tour.id === 0 ? 'create' : 'edit';
        R.handle(R.transfer[action], tour, onSuccess, onFailure, LOADER.POPUP);
    }

    const initDepartments = () => {
        if (user.isAdmin()) {
            departments = copyObject(initData.departments);
            departments = [{id: 0, name: "select department"}, ...departments];
        } else {
            departments = initData.departments.filter(x => x.users.indexOf($user.id) > -1);
            if (!tour.department_id) {
                tour.department_id = departments[0].id;
                onDepartmentChange();
            }
        }
    }

    const initUsers = (department) => {
        users = [];

        if (!user.isAdmin()) {
            // User is a department user
            users = [{id: $user.id, name: $user.name}];
            return;
        }

        if (!department) {
            department = initData.departments.find(x => x.id == tour.department_id);
        }
        if (department) {
            // set department users
            department.users.map(user_id => {
                let user = initData.users.find(x => x.id == user_id);
                if (user) {
                    users = [...users, user];
                }
            });
        }

        // add original transfer user in department users
        if (transferUser && !users.filter(x => x.id == transferUser.id).length) {
            users = [transferUser, ...users];
        }

        // add current user in department users in not exist
        if (!users.filter(x => x.id == $user.id).length) {
            users = [{id: $user.id, name: $user.name}, ...users];
        }
    }

    const onDepartmentChange = () => {
        hotels = [];

        // add start points in default locations
        defaultLocations = initData.locations.filter(x => x.is_start_point == 1);

        let department = initData.departments.find(x => x.id == tour.department_id);
        if (department) {
            // find department account
            account = initData.accounts.find(x => x.id == department.account_id);
            tour.account_id = department.account_id;

            // add department hotels in default locations
            department.hotels.map(id => {
                let location = initData.locations.find(x => x.hotel_id == id);
                if (location) {
                    defaultLocations = [...defaultLocations, location];
                }

                let hotel = initData.hotels.find(x => x.id == id);
                if (hotel) {
                    hotels = [...hotels, hotel];
                }
            });
        } else {
            tour.account_id = 0;
            tour.department_id = 0;
            account = null;
        }

        initUsers(department);
    }

    const addVehicleType = () => {
        tour.vehicles = [...tour.vehicles, {
            vehicle_type_id: $app.vehicle_types[0].id,
            transporter_id: 0,
            vehicle: null,
            driver: null,
        }];
    }

    const removeVehicleType = (index) => {
        tour.vehicles.splice(index, 1);
        tour.vehicles = transfer.vehicles;
    }


    Object.keys(CUSTOMER_TYPE).map(key => {
        customerTypes.push({
            id: CUSTOMER_TYPE[key],
            name: CUSTOMER_TYPES[CUSTOMER_TYPE[key]]
        });
    });

    Object.keys(TRANSFER_STATUS).map(key => {
        statuses.push({
            id: TRANSFER_STATUS[key],
            name: TRANSFER_STATUSES[TRANSFER_STATUS[key]]
        });
    });


    initialize();

    $: {
        if (tour) {
            maxPassengers = 0;
            tour.vehicles.map(vehicle => {
                let item = $app.vehicle_types.find(x => x.id == vehicle.vehicle_type_id);
                if (item) {
                    maxPassengers += parseInt(item.max_pax);
                }
            });
            totalPassengers = parseInt(tour.adults) + parseInt(tour.children) + parseInt(tour.infants);
        }
    }
</script>
<!--{#if $transfers.list != null}-->
<Breadcrumb {breadcrumb}/>
<!--{/if}-->
<PageHeader title={pageTitle}/>
{#if tour}
    <div class="transfer">
        <div class="row">
            <div class="col-xl-5 col-lg-7">
                <div class="panel border-default mb-5">
                    <div class="panel-body panel-pad">
                        {#if account}
                            <h5>{account.name}</h5>
                        {:else}
                            <h5>No Account!</h5>
                        {/if}
                        {#if user.isAdmin()}
                            <div class="row mb-4">
                                <div class="col-xl-6 form-group">
                                    <label>Department</label>
                                    <select class="form-select" bind:value="{ tour.department_id }"
                                            on:change={ onDepartmentChange }>
                                        {#each departments as item}
                                            <option value="{ item.id }">{ item.name }</option>
                                        {/each}
                                    </select>
                                </div>
                                <div class="col-xl-6 form-group">
                                    <label>User</label>
                                    {#if users.length}
                                        <select class="form-select" bind:value="{ tour.user_id }">
                                            {#each users as item}
                                                <option value="{ item.id }">{ item.name }</option>
                                            {/each}
                                        </select>
                                    {:else}
                                        {#if tour.department_id > 0}
                                            <div class="form-control text-light">department has no users!</div>
                                        {:else}
                                            <div class="form-control text-light">select department first</div>
                                        {/if}
                                    {/if}
                                </div>
                            </div>
                        {:else}
                            <div class="form-group">
                                <label>Department</label>
                                <select class="form-select" bind:value="{ tour.department_id }"
                                        on:change={ onDepartmentChange }>
                                    {#each departments as item}
                                        <option value="{ item.id }">{ item.name }</option>
                                    {/each}
                                </select>
                            </div>
                        {/if}

                        <div class="mb-5">
                            <div class="route">
                                <legend class="fw-semibold">
                                    Tour
                                </legend>
                                <div class="row">
                                    <div class="col-xl-6 col-lg-6 col-md-6">
                                        <div class="form-group">
                                            <label>From</label>
                                            <RouteLocation {defaultLocations} bind:location="{ pickup }"
                                                           placeholder="location name"/>
                                        </div>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-6">
                                        <div class="form-group">
                                            <label>Tour</label>
                                            <select class="form-select" bind:value={tour.tour_id}>
                                                <option value={0}>select tour</option>
                                                {#each initData.tours as item}
                                                    <option value={item.id}>{item.name}</option>
                                                {/each}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--                            <TourRoute bind:pickup={ pickup } bind:drop="{ drop }" {initData.tours}/>-->
                            <div class="row">
                                <div class="col form-group">
                                    <label>Date</label>
                                    <DateControl id="transferDate" bind:value="{ transferDate }"/>
                                </div>
                                <div class="col form-group">
                                    <label>Time</label>
                                    <TimeControl id="transferTime" bind:time="{ transferTime }"/>
                                </div>
                            </div>
                        </div>

                        <legend>
                            <h6 class="mb-0">Vehicle</h6>
                            <button class="btn btn-primary btn-xs btn-flex" on:click="{ addVehicleType }">
                                <AppIcon icon="plus-circle" size="16" strokeWidth="2" left/>
                                add vehicle
                            </button>
                        </legend>
                        <div class="mb-5">
                            {#each tour.vehicles as item, index}
                                <div class="input-group" class:mb-1={ tour.vehicles.length > 1}>
                                    <select class="form-select"
                                            bind:value="{ tour.vehicles[index].vehicle_type_id }">
                                        {#each $app.vehicle_types as item}
                                            <option value="{ item.id }">{ item.name } ({ item.description })</option>
                                        {/each}
                                    </select>
                                    {#if index > 0}
                                        <button class="btn btn-default" title="remove vehicle"
                                                on:click="{ () => removeVehicleType(index) }">
                                            <AppIcon icon="x" size="16"/>
                                        </button>
                                    {/if}
                                </div>
                            {/each}
                        </div>

                        <legend>
                            <h6 class="mb-0">Passengers</h6>
                            {#if maxPassengers > 0}
                                <div class="fw-semibold">{ totalPassengers } / { maxPassengers }</div>
                            {/if}
                        </legend>
                        <div class="row">
                            <div class="col-md-4 col-sm-12 form-group">
                                <label>Adults</label>
                                <NumberSpinner bind:value="{ tour.adults }"/>
                            </div>
                            <div class="col-md-4 col-sm-12 form-group">
                                <label>Children</label>
                                <NumberSpinner bind:value="{ tour.children }"/>
                            </div>
                            <div class="col-md-4 col-sm-12 form-group">
                                <label>Infants</label>
                                <NumberSpinner bind:value="{ tour.infants }"/>
                            </div>
                        </div>

                        {#if tour.children > 0 || tour.infants > 0}
                            <hr class="hidden-xl hidden-lg hidden-md">
                            <div class="row">
                                <div class="col-md-4 col-sm-12 form-group">
                                    <label>Boosters</label>
                                    <NumberSpinner bind:value="{ tour.booster_seats }"/>
                                </div>
                                <div class="col-md-4 col-sm-12 form-group">
                                    <label>Baby seats</label>
                                    <NumberSpinner bind:value="{ tour.baby_seats }"/>
                                </div>
                                <div class="col-md-4 col-sm-12 form-group">
                                    <label>Infant seats</label>
                                    <NumberSpinner bind:value="{ tour.infant_seats }"/>
                                </div>
                            </div>
                        {/if}

                        {#if maxPassengers > 0 && totalPassengers > maxPassengers}
                            <div class="alert alert-danger p-2 mb-0">
                                Too many passengers... consider adding more vehicles
                            </div>
                        {/if}
                    </div>
                </div>
            </div>

            <div class="col-xl-3 col-lg-5">

                <div class="panel border-default mb-5">
                    <div class="panel-body panel-pad">
                        <div class="form-group">
                            <h5>Customer</h5>
                            <select class="form-select" bind:value="{ tour.customer_type }">
                                {#each customerTypes as item}
                                    <option value="{ item.id }">{ item.name }</option>
                                {/each}
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Name</label>
                            <input type="text" class="form-control" id="customerName"
                                   bind:value="{ tour.customer.fullname }">
                        </div>
                        <div class="form-group">
                            <label>Phone</label>
                            <input type="tel" class="form-control" bind:value="{ tour.customer.phone }">
                        </div>
                        <div class="form-group">
                            <label>Email</label>
                            <input type="email" class="form-control" bind:value="{ tour.customer.email }">
                        </div>
                        <div class="form-group">
                            <label>Room No</label>
                            <input type="text" class="form-control width-50" bind:value="{ tour.customer.room_no }">
                        </div>
                        <div>
                            <label>Notes</label>
                            <textarea class="form-control" bind:value="{ tour.notes }"
                                      placeholder="notes"></textarea>
                            {#if tour.reservation}
                                <p class="small mb-0">
                                    Warning: notes can be visible to customer!
                                </p>
                            {/if}
                        </div>
                    </div>
                </div>

                {#if tour.reservation}
                    <TransferReservation transfer={tour} reservation={tour.reservation}/>
                {/if}

            </div>
            <div class="col-xl-4 col-lg-12">
                {#if user.isAdmin()}
                    <TransferVehicles bind:vehicles={ tour.vehicles } bind:notes={ tour.driver_notes }
                                      transferId="{ tour.id }" {transferDate}/>
                {/if}
                {#if $user.role == USER_ROLE.GOD}
                    <div class="col-xl-12">
                        <TransferCommissions accounts="{initData.accounts}" departments="{initData.departments}"
                                             transfer={tour}
                                             bind:commissions={commissions}/>
                    </div>
                {:else if user.isDepartmentAdmin()}
                    <div class="panel panel-default mb-5">
                        <div class="panel-heading">Pricing</div>
                        <div class="panel-body panel-pad">
                            <div class="form-group">
                                <label>Cost</label>
                                <div class="commission-price">
                                    <PriceControl bind:value="{ tour.price }" placeholder="€"/>
                                </div>
                            </div>
                        </div>
                    </div>
                {/if}
                <div class="panel panel-default mb-5">
                    <div class="panel-heading">Status</div>
                    <div class="panel-body panel-pad">
                        <select class="form-select" bind:value="{ tour.status_id }">
                            {#each statuses as status}
                                <option value="{ status.id }">{ status.name }</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="panel border-default mb-4">
            <div class="panel-body panel-pad">
                <div class="row">
                    <div class="col-xl-8">
                        {#if tour.created_at}
                            <div>
                                Created: <span class="text-gray">{ formatDate(tour.created_at, 'd-m-y H:i') }</span>
                            </div>
                        {/if}
                        {#if tour.updated_at}
                            <div>
                                Updated: <span class="text-gray">{ formatDate(tour.updated_at, 'd-m-y H:i') }</span>
                            </div>
                        {/if}
                    </div>

                    <div class="col-xl-4 text-end">
                        <button class="btn btn-primary btn-lg px-5" on:click="{ save }">SAVE</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/if}
{#if tourId == -1}
    <PageNotFound message="Tour not found!"/>
{/if}